export enum SelectionPanelGroupStyleMode {
    /** Bordered card per item with a round check button (the original look). */
    Enhanced = 'enhanced',
    /** Compact checklist: square checkbox and text, no card; the selected item's text is bold. */
    Condensed = 'condensed',
}
